module.exports = __webpack_public_path__ + "static/media/search.1484b955.svg";